import { Button, ButtonGroup, Box, Icon, SubHeading, Paragraph, Heading } from '@alto-avios/alto-ui'
import Head from 'next/head'
import Image from 'next/image'
import { getPublicAssetSrc } from '~/utils/assets'
import { useAuthContext } from '~/context/auth'
import { useTranslations } from 'next-intl'
import { useParseRichTextMessage } from '~/hooks/useParseRichTextMessage/useParseRichTextMessage'

const BARCMemberLayout = () => {
  const { getAuthHref } = useAuthContext()
  const t = useTranslations('components.barc_member_upgrade')
  const { parser } = useParseRichTextMessage('components.barc_member_upgrade')

  return (
    <>
      <Head>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <title>British Airways, upgrade to Executive Club</title>
      </Head>

      <Box
        flexDirection="column"
        height="100vh"
        width="100vw"
        justifyContent="center"
        alignItems="center"
        style={{ height: '100vh' }}
      >
        <Box flexDirection="column" justifyContent="center" maxWidth="23rem" gap="md">
          <Box
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            padding="lg"
            gap="md"
          >
            <Image
              src={getPublicAssetSrc('/assets/british-airways-executive-club.svg')}
              alt="British Airways Executive Club Logo"
              height={80}
              width={300}
            />
            <Heading size="sm" padding="md" textAlign="center">
              {parser('labels.upgrade_heading')}
            </Heading>
          </Box>

          <SubHeading size="xs" textAlign="start">
            {t('labels.upgrade_sub_heading')}
          </SubHeading>
          <Paragraph>
            <Box gap="xs">
              <Icon isDecorative iconName="circle-check" />
              <span>{t('labels.upgrade_benefit_one')}</span>
            </Box>
            <Box gap="xs">
              <Icon isDecorative iconName="circle-check" />
              <span>{t('labels.upgrade_benefit_two')}</span>
            </Box>
            <Box gap="xs">
              <Icon isDecorative iconName="circle-check" />
              <span>{t('labels.upgrade_benefit_three')}</span>
            </Box>
          </Paragraph>
          <ButtonGroup align="stack">
            <Button
              as="a"
              href="https://www.britishairways.com/travel/EXECENROL/public/en_gb"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t('actions.upgrade_cta_label')}
            </Button>
            <Button as="a" href={getAuthHref('LOGOUT')} emphasis="quaternary">
              {t('actions.back_to_login_button_label')}
            </Button>
          </ButtonGroup>
        </Box>
      </Box>
    </>
  )
}

export default BARCMemberLayout
